import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import styles from './CustomDropdown.module.scss';
import cn from 'classnames';
import Arrow from '../../Icons/Arrow';

export default function CustomDropdown({
  options,
  placeholderValue,
  selectedValue,
  isOptionsAbsolutePosition,
  onSelect,
  disabled = false,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(selectedValue || null);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    if (!disabled) {
      setIsOpen((prev) => !prev);
    }
  };

  const handleOptionClick = (option) => {
    setSelected(option);
    setIsOpen(false);
    if (onSelect) {
      onSelect(option);
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // 监听 selectedValue 变化
  useEffect(() => {
    setSelected(selectedValue || null);
  }, [selectedValue]);

  return (
    <div className={styles.dropdown} ref={dropdownRef}>
      <div
        className={cn(
          styles.selected,
          isOpen && styles.selected_active,
          disabled && styles.selected_disabled
        )}
        onClick={toggleDropdown}
      >
        {selected ? selected.label : placeholderValue || options[0].label}
        <span className={styles.arrow}>
          <Arrow isRotated={isOpen} color="#121212" strokeWidth="1" />
        </span>
      </div>
      {!disabled && (
        <motion.ul
          className={cn(
            styles.options,
            isOptionsAbsolutePosition && styles.options_positionAbsolute
          )}
          initial={{ height: 0, opacity: 0 }}
          animate={isOpen ? { height: 'auto', opacity: 1 } : { height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          style={{ overflow: 'overlay' }}
        >
          {options.map((option) => (
            <li
              key={option.value}
              className={styles.option}
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </li>
          ))}
        </motion.ul>
      )}
    </div>
  );
}
